var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemChannelFlickr = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M16.444 8a3.555 3.555 0 1 1 0 7.11 3.555 3.555 0 0 1 0-7.11M7.556 8a3.555 3.555 0 1 1 0 7.11 3.555 3.555 0 0 1 0-7.11m8.888 1.778a1.778 1.778 0 1 0 0 3.555 1.778 1.778 0 0 0 0-3.555"
})));
export default SvgGemChannelFlickr;